import React, { useState, useEffect } from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { Btn, H3, P } from '../../../../AbstractElements';
import { serviceAccount, servicePlanHistory, serviceRequest, StbModem, Subscription, SubscriptionHistory } from '../../../../Constant';
import { useSelector } from 'react-redux';
import DataTable from 'react-data-table-component';
import { getClientUrlDataToken } from '../../../../Utils/restUtils';
import { getComplaint, getServicePlanHistory, getServicePlanHistoryRole, getUserStb, getUserStbRole } from '../../../../CommonUrl';
import { StbColumns, userServiceAccountColumns, userServicePlanHistoryColumns, userServiceRequestColumns } from '../../../../Data/MockTable/UserTableHeader';
import { conditionalRowStyles } from '../../../Common/Rowstyle/Rowstyle';
import { useNavigate } from 'react-router-dom';

const ServicePlanHistory = (props) => {
    const propsId = props.param;
    const authState = useSelector((state) => state.auth);
    const [stbList, setStbList] = useState([]);
    const [perPage, setPerPage] = useState(10);
    const [totalRows, setTotalRows] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const navigate = useNavigate()

    useEffect(() => {
        stbData(currentPage, perPage);
    }, []);

    const handlePageChange = page => {
        stbData(page, perPage,);
        setCurrentPage(page);
    };

    const handlePerRowsChange = async (newPerPage, page) => {
        stbData(page, newPerPage);
        setPerPage(newPerPage);
    };

    const stbData = async (page, size = perPage) => {

        let data = await getClientUrlDataToken(authState.apiUrl, authState.userRole === 1 ?
            getServicePlanHistory + `?page=${page}&page_length=${size}&customer_id=${propsId}` : getServicePlanHistoryRole + `?page=&page_length=&search=&customer_id=${propsId}`);
            if (data?.status === true) {
             const SerialNo = (page - 1) * size + 1;
            setStbList(data?.data?.map((e, index) => {
                return {
                    Si: SerialNo + index,
                    serviceName: e?.service_plan_name||'N/A',
                    lasteServiceDate:e?.last_service_date||'N/A',
                    nextServiceDate:e?.next_service_due_date||'N/A',
                    startDate:e?.service_start_date||'N/A',
                    endDate:e?.service_end_date||'N/A',
                    serviceAccNo:e?.service_account_no||'N/A'
                }
            }))
        setTotalRows(data.data.total);

        } else if (data.status >= 400 && data.status <= 405) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page1`);
        } else if (data.status >= 500 && data.status <= 505) {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page4`);
        }
        else {
            navigate(`${process.env.PUBLIC_URL}/pages/error/error-page3`);
        }
    };
    return (
        <Col sm="12"  xl="xl-100">
            <Card>
                <CardHeader>
                    <H3 attrH3={{ style: { paddingLeft: '10px' } }}>{servicePlanHistory}</H3>
                </CardHeader>
                <CardBody>
                    <div className="order-history table-responsive" style={{ marginTop: '-40px', maxHeight: '300px' }}>
                        <DataTable
                            data={stbList}
                            columns={userServicePlanHistoryColumns}
                            conditionalRowStyles={conditionalRowStyles}
                            // pagination
                            // paginationTotalRows={totalRows}
                            // paginationDefaultPage={currentPage}
                            // onChangeRowsPerPage={handlePerRowsChange}
                            // onChangePage={handlePageChange}
                        />
                    </div>
                </CardBody>
            </Card>
        </Col>
    );
};

export default ServicePlanHistory;